export const shouldHideHeader = (path = ''): boolean => {
    return (
        path.includes('inspection-app-report') ||
        path.includes('loan-application-draft-docs-create') ||
        path.includes('loan-application-draft-create')
    );
};
